import { v as o } from "../validate-feature-flags-config-CA-0XsPn.mjs";
function n(e, a, r) {
  var l;
  if (!r)
    return !1;
  const t = r[e];
  return t ? !!(t.enabledGlobally || ((l = t.markets) == null ? void 0 : l[a.toUpperCase()])) : !1;
}
const F = (e) => {
  globalThis.smart_featureFlags = e;
}, s = () => globalThis.smart_featureFlags, f = (e, a) => {
  const r = s();
  return r || console.error("featureFlags are not set in globalThis."), n(e, a || "", r);
}, g = (e) => {
  const a = s();
  if (!a)
    throw Error("featureFlags are not set in globalThis.");
  return o(a, e);
};
export {
  s as getGlobalFeatureFlags,
  n as isFeatureFlagEnabled,
  f as isGlobalFeatureFlagsEnabled,
  F as setGlobalFeatureFlags,
  o as validateFeatureFlagsConfig,
  g as validateGlobalFeatureFlagsConfig
};
//# sourceMappingURL=index.mjs.map
